/**
 * Logger object. Helpful to log messages from different parts of the code.
 *
 * Example:
 * ```javascript
 * import Logger from '@/utils/logger'
 *
 * logger = new Logger('store/auth')
 * logger.warn('foo')
 * // Prints with console.warn:
 * // [store/auth] foo
 * ```
 */
export default class Logger {
  constructor(namespace) {
    const format = message => `[${namespace}] ${message || ''}`

    /* eslint-disable no-console */
    this.error = error => console.error(format(), error)
    this.warn = message => console.warn(format(message))
    this.log = message => console.log(format(message))
    /* eslint-enable no-console */

  }
}
